// extracted by mini-css-extract-plugin
export default {"container":"SY-z","darkBackground":"TY-z","whiteBackground":"UY-z","headerButton":"VY-z","calloutHeading":"WY-z","calloutSubHeading":"XY-z"};